import React from "react";
import InvestigationsLabel from "security-app/components/common/InvestigationsLabel";
const statusBadgeStyle = (status) => {
  switch (status) {
    case "CONFIRMED":
      return "success";
    case "ESCALATED":
      return "warning";
    case "SUPPRESSED":
      return "default";
    case "EVALUATED":
    default:
      return "info";
  }
};
const TriageStatus = ({
  status,
  count = void 0
}) => /* @__PURE__ */ React.createElement(InvestigationsLabel, { bsStyle: statusBadgeStyle(status) }, status, count !== void 0 ? ` ${count}` : "");
export default TriageStatus;
